<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const language = ref('chi')
const route = useRoute()
const router = useRouter()
const showError = ref(false)

onMounted(async () => {
  try {
    route?.query?.err_ref && await router.replace({
      path: route.query.err_ref,
      query: route.query
    })
  } catch (error) {
    console.error(error)
  }
  showError.value = true
  document.getElementById('tvb-loading').style.display = 'none'
  document.getElementById('tvb').style.opacity = '1'
  // window.history.replaceState(history.state, null, '/notice.html')
})
</script>

<template>
  <div class="error-page">
    <div class="tvb-404" v-if="showError">
      <div class="error-switching-languages">
        <div
          class="error-switching-language"
          @click="language = 'chi'"
          :class="{ active: language === 'chi' }"
        >
          <p>中文</p>
        </div>
        <div
          class="error-switching-language"
          @click="language = 'eng'"
          :class="{ active: language === 'eng' }"
        >
          <p>English</p>
        </div>
      </div>
      <div class="error-icon"><tvb-svg-icon class="icon-404" name="img_404" /></div>
      <div class="error-content" v-if="language === 'chi'">
        <div class="error-title">多謝您瀏覽TVB.COM</div>
        <div class="error-des">
          <p>閣下所尋找的網址並不存在</p>
          <p>這有可能因為該網頁已被移除、轉址、或暫停</p>
          <p>我們建議您</p>
          <p>檢查您剛輸入的網址是否正確</p>
          <p>返回 <tvb-router-link to="/">TVB.COM</tvb-router-link> 的主頁繼續瀏覽最新資料</p>
        </div>
      </div>
      <div class="error-content" v-if="language === 'eng'">
        <div class="error-title">Thank you for visiting TVB.COM</div>
        <div class="error-des">
          <p>The page you requested cannot be found.</p>
          <p>It might have been removed, relocated, or is temporarily unavailable.</p>
          <p>Please try the following:</p>
          <p>Make sure the URL you entered is spelt correctly.</p>
          <p>
            Visit the <tvb-router-link to="/">TVB.COM</tvb-router-link> homepage and browse the most
            updated content.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0 !important;
  padding-bottom: 0 !important;

  .tvb-404 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    max-width: 1280px;
    position: relative;
    width: 100%;

    .error-content {
      max-width: 640px;
      // width: calc(100% - 200px - 48px);
    }

    .error-switching-languages {
      width: 166px;
      height: 34px;
      background: #f0f1f2;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      .error-switching-language {
        width: 80px;
        height: 28px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          width: 60px;
          height: 22px;
          text-align: center;
          font-weight: 500;
          font-size: 16px;
          color: #818d95;
          line-height: 22px;
          letter-spacing: 0.5;
        }

        &:hover {
          p {
            color: #0062a3;
          }
        }

        &.active {
          background: #ffffff;
          p {
            color: #0062a3;
          }
        }
      }
    }
  }

  &.s,
  &.xs {
    justify-content: stretch;
    padding-top: 118px !important;
    padding-bottom: 118px !important;
    position: relative;
    .tvb-404 {
      flex-direction: column;
      height: unset;
      position: unset;
      align-items: flex-start;
      .error-icon {
        padding-left: 12px;
      }

      .error-switching-languages {
        top: 24px;
        right: 12px;
        width: 126px;
        height: 28px;
        background: #f0f1f2;
        border-radius: 4px;

        .error-switching-language {
          width: 61px;
          height: 24px;
          border-radius: 3px;
          line-height: 24px;
          p {
            width: 51px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.3px;
          }
        }
      }
    }
  }

  a {
    text-decoration: none;
    background-color: transparent;
    color: #0062a3;
    &:visited {
      color: #0062a3;
    }
    &:hover {
      text-decoration: underline;
    }
  }

  .error-icon {
    margin-right: 48px;
  }
  .icon-404 {
    height: 200px;
    width: 300px;
  }
  .error-title {
    color: #1e1e1e;
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 34px;
    margin-bottom: 24px;
  }
  .error-des {
    color: #333333;
    font-size: 18px;
    letter-spacing: 0.8px;
    line-height: 32px;
  }

  &.s,
  &.xs {
    .error-icon {
      margin-right: 0;
      margin-bottom: 16px;
    }
    .icon-404 {
      height: 120px;
      width: 180px;
    }
    .error-content {
      padding: 0 12px;
      width: unset;
    }
    .error-title {
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 12px;
    }
    .error-des {
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.5px;
    }
  }
}
</style>
